export default "__VITE_ASSET__DcxuzXM$__"